import React from "react";
import { Link } from "react-router-dom";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";

const DIYSolarResources = () => {
  return (
    <div>
      <Navbar />
      <div className="flex flex-col lg:flex-row gap-8 pt-8 bg-gray-100">
        {/* Main Content Section */}
        <div className="lg:w-2/3 bg-white p-6 rounded shadow">
          <h1 className="text-2xl font-bold mb-4">
            Useful Resources For DIY Solar
          </h1>
          <h2 className="text-lg font-semibold mb-2">
            Ampacity Ratings For Insulated Conductors NEC 2007
          </h2>
          <p className="text-gray-600 mb-4">
            Ampacities of not more than three current-carrying conductors in
            raceway, cable, or earth. Based on ambient temperature of 30°C
            (86°F).
          </p>
          {/* Add the image here */}
          <div className="overflow-auto">
            <img
              src="/Assets/ampacity.webp" // Replace with the actual path to your image
              alt="Ampacity Ratings for Insulated Conductors NEC 2007"
              className="rounded shadow w-full"
            />
          </div>
          <p className="text-gray-600 mb-4">
            ampacity ratings for insulated conductors
          </p>
          <br />
          <div className="overflow-auto">
            <img
              src="/Assets/windynation-wires.webp" // Replace with the actual path to your image
              alt="Ampacity Ratings for Insulated Conductors NEC 2007"
              className="rounded shadow w-full"
            />
            <p className="text-gray-600 mb-4">
              <Link to="/">Click here to shop </Link>for these cables.
            </p>
          </div>
          <br />
          <h2 className="text-lg font-semibold mb-2">
            Temperature Correction Factor for wires
          </h2>
          <img
            src="/Assets/ambient.webp" // Replace with the actual path to your image
            alt="Ampacity Ratings for Insulated Conductors NEC 2007"
            className="rounded shadow w-full"
          />
          <br />
          <h2 className="text-lg font-semibold mb-2">
            GHI Solar Irradiance in North-America
          </h2>
          <img
            src="/Assets/GHI-solar.webp" // Replace with the actual path to your image
            alt="Ampacity Ratings for Insulated Conductors NEC 2007"
            className="rounded shadow w-full"
          />
          <p className="text-gray-600 mb-4">
            GHI solar irradiance north america
          </p>
          <br />
          <h2 className="text-lg font-semibold mb-2">Wire selection for DC</h2>
          <img
            src="/Assets/DC-wire.webp" // Replace with the actual path to your image
            alt="Ampacity Ratings for Insulated Conductors NEC 2007"
            className="rounded shadow w-full"
          />
          <br />
          <div className="p-6 ">
            <div className="bg-white p-6  ">
              <h2 className="text-2xl font-bold mb-4">Gauge to mm²</h2>
              <div className="overflow-auto">
                <table className="table-auto w-full border-collapse border border-gray-300 text-left">
                  <thead>
                    <tr className="bg-gray-200">
                      <th className="border border-gray-300 px-4 py-2">
                        Gauge
                      </th>
                      <th className="border border-gray-300 px-4 py-2">mm²</th>
                    </tr>
                  </thead>
                  <tbody>
                    {/* Table rows */}
                    {[
                      { gauge: "16", mm: "1.5mm²" },
                      { gauge: "14", mm: "2.5mm²" },
                      { gauge: "12", mm: "4.0mm²" },
                      { gauge: "10", mm: "6.0mm²" },
                      { gauge: "8", mm: "10mm²" },
                      { gauge: "6", mm: "16mm²" },
                      { gauge: "4", mm: "25mm²" },
                      { gauge: "2", mm: "35mm²" },
                      { gauge: "1", mm: "50mm²" },
                      { gauge: "1/0", mm: "55mm²" },
                      { gauge: "2/0", mm: "70mm²" },
                      { gauge: "3/0", mm: "95mm²" },
                      { gauge: "4/0", mm: "120mm²" },
                    ].map((row, index) => (
                      <tr
                        key={index}
                        className={index % 2 === 0 ? "bg-white" : "bg-gray-100"}
                      >
                        <td className="border border-gray-300 px-4 py-2">
                          {row.gauge}
                        </td>
                        <td className="border border-gray-300 px-4 py-2">
                          {row.mm}
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          </div>
          <p className="text-gray-600 mb-4">
            <Link
              to="https://www.rapidtables.com/calc/wire/voltage-drop-calculator.html"
              className="ml-12 text-green-500 hover:underline"
            >
              Voltage drop calculator
            </Link>
          </p>
        </div>

        {/* About Me Section */}
        <div className="lg:w-1/3 bg-white p-6 rounded shadow">
          <h2 className="text-xl text-center font-bold mb-4">About Me</h2>
          <img
            src="https://via.placeholder.com/150" // Replace with your actual image URL
            alt="About Me"
            className="rounded mb-4"
          />
          <p className="text-gray-600">
            Welcome to Cleversolarpower.com! I'm the driving force behind this
            site, which attracts over 1,000 daily visitors interested in solar
            energy. I'm also the author of a popular solar energy book, with
            over 80,000 copies sold and more than 2,000 reviews averaging 4.5
            stars. My mission is to demystify solar power and make it accessible
            to everyone. Join me in exploring the potential of solar power to
            create a cleaner, brighter future! Link to the book on Amazon. Read
            more about me here, check out my Youtube channel, or send me a
            message.
          </p>
        </div>
      </div>
      <a
        href="https://wa.me/+2348165213568?text=Hi!%20I%20have%20a%20query."
        target="_blank"
        rel="noopener noreferrer"
        className="fixed bottom-4 right-4 bg-green-500 p-3 rounded-full shadow-lg hover:bg-green-200"
      >
        <img
          src="/Assets/chat.png" // <-- Replace this with the actual image path or URL from Flaticon
          alt="WhatsApp Chat"
          className="w-8 h-8" // Tailwind sizes (e.g., w-6 = 24px)
        />
      </a>
      <Footer />
    </div>
  );
};

export default DIYSolarResources;
